import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as loadImage from 'blueimp-load-image';
import { AppHelper } from 'src/app/helpers/app.helper';
import { FileSenderHelper } from 'src/app/helpers/fileSender.helper';
import { ImageHelper } from 'src/app/helpers/image.helper';
import { AppModesEnum } from 'src/app/models/WebServer/appModesEnum';
import { PartecipantStatus } from 'src/app/models/WebServer/partecipantStatus';
import { AppConfigService } from 'src/app/services/app.config.service';
import { FELoggerService, LogSource } from 'src/app/services/feLogger.service';
import { I18Service } from 'src/app/services/i18.service';
import { MediaDeviceService } from 'src/app/services/media-device.service';
import { MediaStremService } from 'src/app/services/media-stream.service';
import { NotificationService } from 'src/app/services/notification.service';
import * as appActions from 'src/app/store/actions/app.actions';
import { AppState } from 'src/app/store/states/app.state';

@Component({
  selector: 'app-caller-snapshot',
  templateUrl: './caller-snapshot.component.html',
  styleUrls: ['./caller-snapshot.component.scss']
})
export class CallerSnapshotComponent implements OnInit {
  @Input() AS!: AppState;
  @Input() MYSTATUS!: PartecipantStatus;

  @ViewChild('localVideoSnapshot') localVideoSnapshot!: ElementRef;
  @ViewChild('canvas') canvas!: ElementRef;
  @ViewChild('snapshotContainer') snapshotContainer!: ElementRef;

  appModes = AppModesEnum;
  uploading = false;
  higher = false;

  AS_video = {
    cameraPermission: true,
    cameraEnabledForSnapshot: false,
    localBig: false,
    captureUrl: ''
  };

  constructor(
    private store: Store<AppState>,
    public mediaService: MediaStremService,
    public mediaDeviceService: MediaDeviceService,
    public config: AppConfigService
  ) {}

  ngOnInit(): void {
    // this.mediaService.setLocalVideoSnapshot(this.localVideoSnapshot?.nativeElement);
  }

  ngAfterViewInit(): void {
    if (this.localVideoSnapshot?.nativeElement) {
      this.mediaService.setLocalVideoSnapshot(this.localVideoSnapshot.nativeElement);
    }
  }

  get doubleCamera(): boolean {
    return this.mediaDeviceService.isMultiCamera;
  }

  get atLeast1Camera(): boolean {
    return this.mediaDeviceService.atLeastACamera;
  }

  async enableSnapshot() {
    await this.mediaService.startLocalVideoSnapshot();
    // if (this.AS.mediaPermission != 2) {
      this.AS_video.cameraEnabledForSnapshot = true;
      this.AS_video.localBig = true;
    // }
  }

  disableSnapshot() {
    this.AS_video.cameraEnabledForSnapshot = false;
    this.AS_video.localBig = true;
    this.mediaService.stopLocalVideoSnapshotStream();
  }

  switchCamera() {
    this.store.dispatch(appActions.switchCamera({ forSnapshot: this.AS_video.cameraEnabledForSnapshot }));
  }

  captureVideoImage() {
    setTimeout(() => {
      const scaleFactor = 1;
      const snapshotElement = this.localVideoSnapshot.nativeElement;
      const w = snapshotElement.videoWidth * scaleFactor;
      const h = snapshotElement.videoHeight * scaleFactor;

      this.canvas.nativeElement.width = w;
      this.canvas.nativeElement.height = h;
      const ctx = this.canvas.nativeElement.getContext('2d');
      ctx.drawImage(snapshotElement, 0, 0, w, h);
      this.AS_video.captureUrl = this.canvas.nativeElement.toDataURL('image/png');

      if (this.snapshotContainer?.nativeElement) {
        if (this.snapshotContainer.nativeElement.clientWidth > this.snapshotContainer.nativeElement.clientHeight) {
          this.higher = false;
        } else {
          this.higher = true;
        }
      }
    }, 200);
  }

  sendCameraImage() {
    try {
      this.uploading = true;
      NotificationService.show(I18Service.get('Loading.now'));
      ImageHelper.resizeImage(this.AS_video.captureUrl + '', this.config.desiredImageSize, this.canvas.nativeElement);
      FileSenderHelper.sendCameraImage(this.AS_video.captureUrl + '', this.AS.partecipantId)
        .then((b: boolean) => {
          this.AS_video.captureUrl = '';
          this.uploading = false;
        });
    } catch (error) {
      this.uploading = false;
      FELoggerService.error('Error Sending Capture Image', LogSource.MediaAudio, error);
      NotificationService.showError('Immagine corrotta');
      NotificationService.popupError({ msg: `Non è stato possibile inviare l'immagine` });
      this.AS_video.captureUrl = '';
    }
  }

  backToVideo() {
    this.AS_video.captureUrl = '';
  }

  openImageGalleryInput() {
    AppHelper.openFilePicker(this.store, 'imageUploader');
  }

  async onImageGalleryChange(e: any) {
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      if (files[i].type.match(/^image\//)) {
        this.scaleSize(files[i]);
        const inputElement = document.getElementById('imageUploader') as HTMLInputElement;
        inputElement.value = '';
        break;
      } else {
        NotificationService.showError(I18Service.get('POPUP.IMAGEERRORTITLE'));
      }
    }
  }

  private scaleSize(file: File) {
    const self = this;
    const scaleFactor = 0.7;

    loadImage(
      file,
      (canvas: any, data: any) => {
        const phoneModel = (data && data.exif) ? `${data.exif['271']} - ${data.exif['272']}` : '';
        const mimeType = 'image/jpeg';
        try {
          NotificationService.show(I18Service.get('Loading.now'));
          let url: string = canvas.toDataURL(mimeType, scaleFactor);

          ImageHelper.resizeImage(url, self.config.desiredImageSize, canvas);
          FileSenderHelper.sendGalleryImageAttachment(url, file.name, self.config.partecipantId).finally(() => {});
        } catch (error) {
          NotificationService.popupWarn({ msg: I18Service.get('POPUP.CORRUPTEDIMGBODY') });
          error && FELoggerService.error(`Error during image Sharing: ${error}`);
        }
      },
      { meta: true, canvas: true, orientation: true }
    );
  }

  openFileInput(divId: string) {
    AppHelper.openFilePicker(this.store, divId);
  }

  async attachDocument(e: any) {
    console.log('attachDocument', e);
    FileSenderHelper.attachDocument(e, this.config.partecipantId);
    const inputElement = document.getElementById('attachmentUploader') as HTMLInputElement;
    inputElement.value = '';
  }

  onFilePickerCancel() {
    console.log('File picker cancelled by user');
    this.store.dispatch(appActions.setSuspended({ message: '' }));
  }
}
